import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'

const BlockStyleTwo = () => {
    return (
        <Fragment>
            <div className="block-style-two text-center pb-90">
                <img
                    className="news-shape-one d-none d-xl-block"
                    src="assets/img/shape/line-round-3a.svg"
                    alt="배경 도형"/>
                <h3>프로젝트를 함께 검토해보세요.<br/>비즈니스 환경에 맞는 구축 방향을 제안드립니다.</h3>
                <Link to="/contact" className="theme_btn">프로젝트 문의하기</Link>
            </div>
        </Fragment>
    )
}

export default BlockStyleTwo
